import React, { FC } from 'react';
import { NotificationVariant } from '../Notifications/types';

import { useAppContext } from '../../../hooks/useAppContext';
import { useTranslation } from 'react-i18next';
import { NotificationContainer } from '../Notifications';
import { useMerchantDelinquencyStatus } from '../../../hooks/useMerchantDelinquencyStatus';

export const MerchantDelinquencyNotification: FC<React.HTMLAttributes<HTMLDivElement>> = (props): Nullable<JSX.Element> => {
  const { t } = useTranslation();
  const { merchantSupportPhone } = useAppContext();
  const isMerchantDelinquent = useMerchantDelinquencyStatus();
  if (!isMerchantDelinquent) return null;
  return (
    <>
    {isMerchantDelinquent?<NotificationContainer
      notificationData={{
        title: 'clover_app_store.billing_error.title',
        body: t('clover_app_store.billing_error.body',{ cloverSupportTelephone : merchantSupportPhone }),
        variant: NotificationVariant.Red,
      }
      }
      notificationProperties={{
        closeTimer: false,
        closeable: true
      }}
      {...props}
      />:null}

      </>
  );
};

